module.exports = __webpack_public_path__ + "static/img/tip.c476c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/address/tip.png
// module id = 2OFa
// module chunks = 1